'use client';

import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Button } from 'shared/ui/button';
import { createPortal } from 'react-dom';
import type { Project } from '@/enteties/project/modal';
const AddForm = dynamic(() => import('./add-form'));
interface AddVariableProps {
  text: string;
  slug: Project['slug'];
  isSecret?: boolean;
}
export const AddVariable = ({
  text,
  slug,
  isSecret = false
}: AddVariableProps) => {
  const [open, setOpen] = useState(false);
  return <>
      <Button type="button" onClick={() => setOpen(true)} size="sm" data-sentry-element="Button" data-sentry-source-file="add-variable.tsx">
        {text}
      </Button>
      {open && createPortal(<AddForm open={open} setOpen={setOpen} isSecret={isSecret} slug={slug} />, document.body)}
    </>;
};